import { Action } from '@ngrx/store';
import { removeModelType } from './RemoveModelAction';
import { IAutoSave } from '../../IAutoSave';
import { AbstractControl } from '@angular/forms/src/model';

export function removeModelSuccessType<TParentModel, TModel>(module: string, parentType: { new(): TParentModel; }, type: { new(): TModel; } | string): string {
  return `${removeModelType(module, parentType, type)} Success`;
}

export class RemoveModelSuccessAction<TParentModel, TModel> implements Action {
  readonly type: string;

  constructor(module: string, parentType: { new(): TParentModel; }, modelType: { new(): TModel; } | string, public payload: { key: string, model: TModel, control: IAutoSave & AbstractControl }) {
    this.type = removeModelSuccessType(module, parentType, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/workspace/store/actions/RemoveModelSuccessAction.ts